import { ProtocolComponent } from "../protocol-configuration/dto/ProtocolComponent";

export class ProtocolComponentMapping {
    private static readonly defaultProtocolMap: Map<string, Array<string>> = new Map([
        ["ALIQUOTATION", ["Start Aliquot.", "Complete Aliquot."]],
        ["AMPLIFY_WGA", ["Start WGA", "Complete WGA"]],
        ["AMPLIFY_PGX", ["Start PGX", "Complete PGX"]],
        ["RECOMBINE_DNA", ["Start Recombine", "Complete Recombine"]],
        ["AMPLIFY_DNA", ["Start Amplifi.", "Complete Amplifi."]],
        ["FRAGMENT_DNA", ["Start Fragmen.", "Complete Fragmen."]],
        ["PRECIPITATION", ["Start Precip.", "Complete Precip."]],
        ["RESUSPEND_DNA", ["Start Resus.", "Complete Resus."]],
        ["DENATURATION", ["Start Denat.", "Complete Denat."]],
        ["PRECELL", ["", ""]],
        ["HYBRIDIZATION", ["Start Hybrid.", "Complete Hybrid."]],
        ["INCUBATION", ["Start Incuba.", "Complete Incuba."]],
        ["STAINING", ["Start Staining", "Complete Staining"]],
        ["DRYING", ["Start Drying", "Complete Drying"]],
        ["IMAGING", ["Start Array Imaging ", "Complete Array Imaging"]],
        ["ANALYSIS", ["Start Analysis", "Complete Analysis"]],
        ["BATCHING",["",""]],
        ["SAMPLE_PLACEMENT",["",""]],
        ["PREPARATION",["Start Preparation","Complete Preparation"]],
        ["LYSIS",["Start Lysis","Complete Lysis"]],
        ["EXTRACTION",["Start Extraction","Complete Extraction"]]
    ])

    static getProtocolComponent(stepName: string) {
        let fieldNames = ProtocolComponentMapping.defaultProtocolMap.get(stepName) || ["", ""];
        return new ProtocolComponent(fieldNames[0], fieldNames[1]);
    }

    static getTitle(stepName:string, position: "START" | "END"): string {
        const titles = ProtocolComponentMapping.defaultProtocolMap.get(stepName) || ["",""];
        return position === "START" ? titles[0] : titles[1];
    }
}

export enum ReceptionComponentName {
    RECEIVE_PLATE = "RECEIVE_PLATE",
    STORE_PLATE = "STORE_PLATE",
    QC_SCAN = "QC_SCAN",
    NANODROP_FAIL = "NANODROP_FAIL",
    NANODROP_PASS = "NANODROP_PASS",
	RECEPTION = "RECEPTION"
}

export enum ProtocolComponentName {
    ALIQUOTATION = "ALIQUOTATION",
    AMPLIFY_WGA = "AMPLIFY_WGA",
    AMPLIFY_PGX = "AMPLIFY_PGX",
    AMPLIFY_DNA = "AMPLIFY_DNA",
    RECOMBINE_DNA = "RECOMBINE_DNA",
    FRAGMENT_DNA = "FRAGMENT_DNA",
    PRECIPITATION = "PRECIPITATION",
    RESUSPEND_DNA = "RESUSPEND_DNA",
    DENATURATION = "DENATURATION",
    PRECELL = "PRECELL"
}

export enum ArrayProtocolComponentName{
    ARRAY_LOADING = "ARRAY_LOADING",
    HYBRIDIZATION = "HYBRIDIZATION",
    INCUBATION = "INCUBATION",
    STAINING = "STAINING",
    DRYING = "DRYING",
    IMAGING = "IMAGING",
    ANALYSIS = "ANALYSIS"
}


export enum ExtractionProtocolComponentName {
    BATCHING = "BATCHING",
    PREPARATION = "PREPARATION",
    LYSIS = "LYSIS",
    EXTRACTION = "EXTRACTION",
    SAMPLE_PLACEMENT = "SAMPLE_PLACEMENT"
}
